import { SortDescriptor } from "react-aria-components";

import { ModuleVersionResourceRow } from "./types";

export const sortModuleVersionResources = (
  resources: ModuleVersionResourceRow[],
  sortDescriptor: SortDescriptor
) => {
  if (!sortDescriptor.column) {
    return resources;
  }

  const direction = sortDescriptor.direction === "ascending" ? 1 : -1;

  return [...resources].sort(
    (a, b) => a.id.localeCompare(b.id, undefined, { numeric: true }) * direction
  );
};
